import request from '../request'

// MF-67 — Journal types API (tenant-managed levels at the top of the inheritance chain).
export const getTypes = (params = {}) => request.get('/journal/types', { params }).then((res) => res)

export const getType = (typeId = '') => request.get(`/journal/types/${typeId}`).then((res) => res)

export const createType = (data = {}) => request.post('/journal/types', data).then((res) => res)

export const updateType = (typeId = '', data = {}) =>
  request.put(`/journal/types/${typeId}`, data).then((res) => res)

export const deleteType = (typeId = '') => request.delete(`/journal/types/${typeId}`).then((res) => res)
